'use client'

import DataLoader from '@/components/reusable/DataLoader'

export default function Loading() {
  return <DataLoader fullPage />
}
